// extracted by mini-css-extract-plugin
export default {"titleText":"TitleText_titleText__CyX5N"};